import { createFileRoute } from '@tanstack/react-router';
import { ReportCentrePage } from '../../../features/reporting/pages/ReportCentrePage';

export const Route = createFileRoute("/_auth/reports/")({
  component: ReportCentrePage,
});
